"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _get2 = _interopRequireDefault(require("@babel/runtime/helpers/get"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _react = _interopRequireDefault(require("react"));
var _aemReactEditableComponents = require("@adobe/aem-react-editable-components");
var _meta = require("../_utils/meta");
var _Carousel = _interopRequireDefault(require("./Carousel"));
var _excluded = ["cq:panelTitle"];
var __jsx = _react.default.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createSuper(t) { var r = _isNativeReflectConstruct(); return function () { var e, o = (0, _getPrototypeOf2.default)(t); if (r) { var s = (0, _getPrototypeOf2.default)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0, _possibleConstructorReturn2.default)(this, e); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var AEMComponentAttributeNames;
(function (AEMComponentAttributeNames) {
  AEMComponentAttributeNames["ComponentType"] = "data-cmp-is";
  AEMComponentAttributeNames["ShouldAutoplay"] = "data-cmp-autoplay-flag";
  AEMComponentAttributeNames["AutoplayInterval"] = "data-cmp-delay-time";
  AEMComponentAttributeNames["ShouldPauseOnHover"] = "data-cmp-pause-on-hover";
  AEMComponentAttributeNames["ShouldWrapAround"] = "data-cmp-wrap-around";
  AEMComponentAttributeNames["CardsPerRotation"] = "data-cmp-cards-per-rotation";
  AEMComponentAttributeNames["PaginationDots"] = "data-cmp-pagination-dots";
  AEMComponentAttributeNames["FullWidth"] = "data-cmp-full-width";
})(AEMComponentAttributeNames || (AEMComponentAttributeNames = {}));
var isAemEditMode = (0, _meta.getWcmmode)() === 'edit';
/**
Below is the class defined for the carousel container and setting various container properties
**/
var CarouselContainer = /*#__PURE__*/function (_Container) {
  (0, _inherits2.default)(CarouselContainer, _Container);
  var _super = _createSuper(CarouselContainer);
  function CarouselContainer() {
    (0, _classCallCheck2.default)(this, CarouselContainer);
    return _super.apply(this, arguments);
  }
  (0, _createClass2.default)(CarouselContainer, [{
    key: "containerProps",
    get: function get() {
      var containerProps = (0, _get2.default)((0, _getPrototypeOf2.default)(CarouselContainer.prototype), "containerProps", this);
      containerProps.className = "".concat(containerProps.className || '', " cmp-carousel cmp-slide-carousel");
      var defaultDelay = '5000';
      containerProps.role = 'group';
      containerProps[AEMComponentAttributeNames.ComponentType] = 'carousel';
      if (this.props.autoplay && !isAemEditMode) {
        containerProps[AEMComponentAttributeNames.ShouldAutoplay] = true;
        containerProps[AEMComponentAttributeNames.AutoplayInterval] = this.props.delay ? this.props.delay : defaultDelay;
        containerProps[AEMComponentAttributeNames.ShouldPauseOnHover] = this.props.autopauseDisabled ? false : true;
        containerProps[AEMComponentAttributeNames.ShouldWrapAround] = true;
      } else {
        containerProps[AEMComponentAttributeNames.ShouldWrapAround] = false;
        containerProps[AEMComponentAttributeNames.ShouldAutoplay] = false;
      }
      containerProps[AEMComponentAttributeNames.CardsPerRotation] = this.props.cardsPerRotation;
      containerProps[AEMComponentAttributeNames.PaginationDots] = this.props.paginationDots;
      containerProps[AEMComponentAttributeNames.FullWidth] = this.props.fullWidth;
      return containerProps;
    }
  }, {
    key: "render",
    value: function render() {
      var carouselItems = this.props.items ? this.props.items : this.props.cqItems && Object.entries(this.props.cqItems).map(function (_ref) {
        var _ref2 = (0, _slicedToArray2.default)(_ref, 2),
          key = _ref2[0],
          value = _ref2[1];
        var _ref3 = value,
          panelTitle = _ref3['cq:panelTitle'],
          rest = (0, _objectWithoutProperties2.default)(_ref3, _excluded);
        return _objectSpread({
          title: panelTitle,
          name: key
        }, rest);
      });
      return carouselItems && carouselItems || isAemEditMode ? __jsx("div", (0, _extends2.default)({}, this.containerProps, {
        id: this.props.anchorId,
        "aria-label": this.props.accessibilityLabel
      }), __jsx("div", {
        className: "cmp-carousel__content"
      }, __jsx(_Carousel.default, {
        isHomepage: this.props.isHomepage,
        isEdit: isAemEditMode,
        shouldAutoplay: this.containerProps[AEMComponentAttributeNames.ShouldAutoplay],
        autoplayInterval: this.containerProps[AEMComponentAttributeNames.AutoplayInterval],
        shouldPauseOnHover: this.containerProps[AEMComponentAttributeNames.ShouldPauseOnHover],
        cardsPerRotation: this.containerProps[AEMComponentAttributeNames.CardsPerRotation],
        isFullWidth: this.containerProps[AEMComponentAttributeNames.FullWidth],
        hasPaginationDots: this.containerProps[AEMComponentAttributeNames.PaginationDots],
        shouldWrapAround: this.containerProps[AEMComponentAttributeNames.ShouldWrapAround]
      }, isAemEditMode || !this.props.isLeadershipVariation ? this.childComponents : this.props.activePanel > -1 && this.props.activePanel < this.childComponents.length ? this.childComponents[this.props.activePanel] : this.childComponents[Math.floor(this.childComponents.length * Math.random())]), ' '), this.placeholderComponent, ' ') : null;
    }
  }]);
  return CarouselContainer;
}(_aemReactEditableComponents.Container);
/**
Below is the edit configuration defined for the carousel component
**/
var CarouselEditConfig = {
  emptyLabel: 'Carousel',
  isEmpty: function isEmpty(props) {
    return !(typeof props.children !== 'undefined' && props.children !== null);
  }
};
var _default = (0, _aemReactEditableComponents.MapTo)('cms-commons/components/content/carousel')(CarouselContainer, CarouselEditConfig);
exports.default = _default;